let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Na4y")).then(() => parcelRequire('chhAm'));